import React from 'react';
import styled from 'styled-components';
import { CharterSection } from './Content.style';
import Header from 'pages/charterQuote/components/contents/Header';
import { H3Text1, NormalSpan } from 'pages/charterQuote/components/contents/Content.style';

const Costs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 24px;
  margin-top: 60px;
`;

const Box = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

const Cost = styled.div`
  max-width: 572px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  padding: 16px 8px;
  border-bottom: 1px solid #dde2e4;

  &:last-child {
    border-bottom: none;
  }

  img {
    width: 24px;
  }
`;

const Imgs = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 40px;

  img {
    width: 50%;
  }
`;

const costComponents = [
  {
    svg: '/imgs/svg/charterQuote/time.svg',
    title: 'Billable Flight Hours',
    desc: "The primary cost is based on the aircraft's hourly rate, multiplied by the number of flight hours required for your trip. This includes the actual travel time.",
  },
  {
    svg: '/imgs/svg/charterQuote/plane.svg',
    title: 'Fuel Surcharge',
    desc: 'The fuel surcharge can fluctuate depending on the aircraft, flight distance, and fuel prices at the time of your trip. These charges are essential for covering the fuel consumption during the flight.',
  },
  {
    svg: '/imgs/svg/charterQuote/people.svg',
    title: 'Crew Fees',
    desc: 'These include per diem payments, meals, accommodations, and other costs associated with the crew’s time and travel.',
  },
  {
    svg: '/imgs/svg/charterQuote/airport.svg',
    title: 'Airport Fees',
    desc: 'These charges vary depending on the aircraft, the airport authority you’re using, and other operational factors, including landing fees, acquiring a landing permit, handling services and ground transport fees.',
  },
  {
    svg: '/imgs/svg/charterQuote/ticket.svg',
    title: 'Federal Excise Tax (FET)',
    desc: 'For domestic flights, a 7.5% federal excise tax is applied to all charges. Government taxes are added to your final charter jet quote.',
  },
];

const PrivateJetQuote = () => {
  return (
    <CharterSection>
      <Header
        title={
          <>
            What’s Included in
            <br />
            Your Private Jet Quote
          </>
        }
        desc={[
          'When you receive private jet quotes, it’s important to understand the key components that make up the cost.',
          "Here's a breakdown of what you can expect, helping you better understand the value behind each charge. While the estimated cost is the range of the average cost for your itinerary, the actual final cost may fluctuate according to aircraft availability.",
        ]}
      />
      <Costs>
        <H3Text1>The main components of a private jet charter cost are:</H3Text1>
        <Box>
          {costComponents.map((item, index) => (
            <Cost>
              <img src={item.svg} alt={item.title} />
              <H3Text1>{item.title}</H3Text1>
              <NormalSpan>{item.desc}</NormalSpan>
            </Cost>
          ))}
        </Box>
      </Costs>

      <Imgs>
        <img src="imgs/webp/charterQuote/luxury.webp" alt="luxury private jet on the tarmac"></img>
        <img
          src="imgs/webp/charterQuote/family.webp"
          alt="Family boarding a private jet for vacation getaway with airacer"
        ></img>
      </Imgs>
    </CharterSection>
  );
};

export default PrivateJetQuote;
